
import { IPerizia, IResult } from './../models/perizia.interface';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { UserService } from './user.service';
import { Observable } from 'rxjs';
import { IFile } from '../models/incarico.interface';
import { IChat } from '../components/chat/models/chat.interface';
import { IDamage } from '../models/damages.interface';
import { MD5 } from '../shared';
import { Platform, ToastController } from '@ionic/angular';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Storage } from '@ionic/storage';
import { LocalNotifications, ScheduleOptions } from '@capacitor/local-notifications';

@Injectable()
export class MysqlService {


  URL_BASE = '';
  marche: any[];
  stati_perizia: any[];

  public uploadQueue: IFileQueue[] = []
  public uploadInProgress: number = null;
  public fileProgress = 0;

  public uploadStatus: 'uploading' | 'done';

  isOfflineMode = false

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private platform: Platform,
    public ionicStorage: Storage,
  ) {



    //this.URL_BASE = window.location.href.split('/').slice(0, 3).join('/');

    //let host = window.location.href.split('/')[2].split(':')[0];

    let env = localStorage.getItem('ENVIRONMENT');
    let envs = []
    try {
      let tmp = localStorage.getItem('ENVIRONMENTs')
      if (tmp) envs = JSON.parse(tmp);
      this.URL_BASE = envs.find(e => e.env == env).url_base
    } catch (error) {
      console.error("db non configurato")
      this.URL_BASE = 'https://xpert-test.ggroup.cloud/api/api.php?cmd='
    }

    console.log('api constructor: ' + this.URL_BASE)

    this.http.get(this.URL_BASE + 'list_perizia_stati').toPromise()
      .then((res: any[]) => {
        this.stati_perizia = res
        localStorage.setItem('stati_perizia', JSON.stringify(res))
      })
      .catch(err => console.error(err))

    this.etax_list_marche().then((res: any[]) => {
      this.marche = res
      localStorage.setItem('marche', JSON.stringify(res))
    })
      .catch(err => console.error(err))

    this.restoreUploadQueue(true)

  }

  sem = false
  async waitForSem(callerName: string) {

    // Finché il semaforo è occupato, attendi
    while (this.sem) {
      console.log(`${callerName} waiting for sem...`);
      await new Promise(resolve => setTimeout(resolve, 50));
    }

    // CRITICO: Occupiamo il semaforo QUI. 
    this.sem = true;
    console.log(`${callerName} acquired sem.`);
  }

  async downloadForOfflineUse(id: number) {
    console.log('downloadForOfflineUse: ' + id + '- sem: ' + this.sem);

    await this.waitForSem('downloadForOfflineUse');

    console.log('downloadForOfflineUse - sem free: ' + id);

    //this.sem = true

    try {


      let offline_data = await this.ionicStorage.get('offline_data')
      console.log('offline_data: ', offline_data);

      if (!offline_data) offline_data = []
      console.log('offline_data: ', offline_data);

      let p = (await this.get_perizia(id))?.item
      console.log('p: ', p);
      let r = (await this.get_perizia_result(id))?.data?.result
      console.log('r: ', r);

      if (r?.offlineDataChanged)
        delete r.offlineDataChanged

      if (r) p.result = r

      let commessa = (await this.commesse_get(p.commessa))?.[0];
      console.log('commessa: ', commessa);
      if (commessa) p.commessa_data = commessa


      offline_data = offline_data.filter(d => d.id != id)
      offline_data.push(p)



      await this.ionicStorage.set('offline_data', offline_data)

    } catch (error) {
      console.error('downloadForOfflineUse error: ', error)
    }



    await this.updateOfflineDataList()

    this.sem = false

  }

  async getOfflineData(id?: number) {

    let offline_data = await this.ionicStorage.get('offline_data')
    return offline_data?.filter(d => d.id == id || !id)
  }

  async getOfflineDataList() {
    let r = await this.ionicStorage.get('offline_data_list')
    console.log('r: ', r);
    return r
  }

  async updateOfflineResult(id: number, result: IResult) {

    await this.waitForSem('updateOfflineResult');

    //this.sem = true

    let offline_data = await this.getOfflineData()

    let item = offline_data?.find(d => d.id == id)

    result.offlineDataChanged = true
    item.result = result

    this.ionicStorage.set('offline_data', offline_data)


    await this.updateOfflineDataList()
    this.sem = false
  }

  async deleteOfflineData(id: number) {
    await this.waitForSem('deleteOfflineData');

    //this.sem = true
    let offline_data = await this.getOfflineData()
    offline_data = offline_data.filter(d => d.id != id)
    await this.ionicStorage.set('offline_data', offline_data)
    this.sem = false

    await this.updateOfflineDataList()
    this.sem = false
  }

  async updateOfflineDataList() {
    console.log('updateOfflineDataList: ');

    //this.sem = true

    try {
      let offline_data = await this.getOfflineData()
      await this.ionicStorage.set('offline_data_list', offline_data.map(d => ({ id: d.id, offlineDataChanged: d.result?.offlineDataChanged })))

    } catch (error) {
      console.error('updateOfflineDataList error: ', error)
    }

  }

  async sendOfflineChanges() {

    await this.waitForSem('sendOfflineChanges');


    //this.sem = true

    try {


      let offline_data = await this.getOfflineData()

      for (const p of offline_data) {

        if (p.result?.offlineDataChanged) {

          let r = await this.perizia_upsert_result(p.id, p.result)
          console.log('offline data upload:  ' + p.id, r);

          if (r.status == 'OK') {
            p.result.offlineDataChanged = false
          }

        }

      }

      await this.ionicStorage.set('offline_data', offline_data)


      await this.updateOfflineDataList()

    } catch (error) {
      console.error('sendOfflineChanges error: ', error)
    }


    this.sem = false

  }




  utenti_validate_otp(otp: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      otp: otp
    }

    return this.http.post(this.URL_BASE + 'utenti_validate_otp', data).toPromise();

  }

  utenti_send_otp_by_email(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
    }

    return this.http.post(this.URL_BASE + 'utenti_send_otp_by_email', data).toPromise();

  }



  get_perizia_result_image_url(img: string) {
    return `${this.URL_BASE}get_perizia_result_image_url&img=${img}`;
  }

  get_vdr_data(targa) {

    let data = {
      auth: this.userService.getCurrentUser(),
      targa: targa,
    }

    return this.http.post(this.URL_BASE + 'unipolrental_get_vdr_data', data).toPromise();

  }




  unipolrental_confirm_appointment(id, dtaAppuntamento) {

    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      dtaAppuntamento: dtaAppuntamento
    }

    return this.http.post(this.URL_BASE + 'unipolrental_confirm_appointment', data).toPromise();

  }

  list_appuntamenti(ispettore = this.userService.getCurrentUser(), showId = 0): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      email: ispettore,
      showId: showId
    }
    return this.http.post(this.URL_BASE + 'list_appuntamenti', data).toPromise();

  }

  sms_send(dest: string, msg: string, send: string, return_id = 0): Promise<any> {
    let data = {
      //auth: this.userService.getCurrentUser(),
      dest: dest.replace('+', ''),
      msg: msg,
      send: send,
      return_id: return_id
    }

    return this.http.post(this.URL_BASE + 'sms_send_anon', data).toPromise();
  }


  fleet_generate_perizia(id: string, washed: boolean): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      washed: washed,
    }
    return this.http.post(this.URL_BASE + 'fleet_generate_perizia', data).toPromise();
  }

  fleet_get_by_plate(plate: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      plate: plate,
    }
    return this.http.post(this.URL_BASE + 'fleet_get_by_plate', data).toPromise();
  }



  commesse_get(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    return this.http.post(this.URL_BASE + 'commesse_get', data).toPromise();
  }


  get_tot_damage(vehType: string, damages: IDamage[]): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      vehType: vehType,
      damages: damages
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'get_tot_damage', data).toPromise();
  }


  ///////////////////////////////////////////////////////////////////////////////////////////

  app_speedtest() {
    let data = {}
    return this.http.get(this.URL_BASE + 'app_speedtest', data).toPromise();
  }

  app_upsert_device_id(token: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      deviceId: token,
      extra: {
        platform: this.platform.platforms().join(','),
      }
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'app_upsert_device_id', data).toPromise();
  }

  etax_list_marche(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser()
    }

    return this.http.post(this.URL_BASE + 'etax_list_marche', data).toPromise();
  }

  etax_list_anni(marca: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      marca: marca
    }

    return this.http.post(this.URL_BASE + 'etax_list_anni', data).toPromise();
  }

  etax_list_modelli(marca: string, anno: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      marca: marca,
      anno: anno
    }

    return this.http.post(this.URL_BASE + 'etax_list_modelli', data).toPromise();
  }

  etax_list_versioni(marca: string, anno: string, modello: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      marca: marca,
      anno: anno,
      modello: modello
    }

    return this.http.post(this.URL_BASE + 'etax_list_versioni', data).toPromise();
  }

  ///////////////////////////////////////////////////////////////////////////////////////////

  list_province(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser()
    }

    return this.http.post(this.URL_BASE + 'list_province', data).toPromise();
  }
  verycar_send_to_uxpert(id, mail): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      mail: mail

    }

    return this.http.post(this.URL_BASE + 'verycar_send_to_uxpert', data).toPromise();
  }
  list_comuni(prov: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      prov: prov
    }

    return this.http.post(this.URL_BASE + 'list_comuni', data).toPromise();
  }

  openBadaPage(item) {
    const { id, targa, marca, modello, versione } = item;
    const queryParams = new URLSearchParams({ id, targa, marca, modello, versione });
    const baseUrl = 'http://localhost:8100/#/new';
    const fullUrl = `${baseUrl}?${queryParams.toString()}`;
    window.open(fullUrl, '_blank');
  }

  ///////////////////////////////////////////////////////////////////////////////////////////

  get_print_adz(id: number, download: boolean) {
    return this.URL_BASE + 'print_adz&header=ie&id=' + id + (download ? '&download=1' : '');
  }

  get_print_adz_perizie(id: number, download: boolean, hash: string, thumb: boolean = false) {
    return this.URL_BASE + 'print_adz_perizie&header=ie&id=' + id
      + '&hash=' + hash
      + (download ? '&download=1' : '')
      + (thumb ? '&thumb=1' : '');
  }

  get_export_url() {
    return this.URL_BASE + 'export';
  }

  get_exp_tab1_url(id: number) {
    return this.URL_BASE + 'exp_tab1&id=' + id;
  }

  get_print_tab1_url(id: number) {
    return this.URL_BASE + 'print_tab1&id=' + id;
  }


  //////////////////////////////////////////////////////////////////////////////////////////

  async get_perizia(id: number): Promise<any> {

    console.log('this.isOfflineMode: ', this.isOfflineMode);
    if (this.isOfflineMode) {
      console.log('Offline mode: returning offline data')
      let r = await this.getOfflineData(id)
      console.log('r: ', r);

      return new Promise(async resolve => resolve({ item: await r[0] }));
    }

    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      type: ''
    }

    return this.http.post(this.URL_BASE + 'get_perizia', data).toPromise();
  }

  async perizia_upsert_result(id: number, result: IResult): Promise<any> {

    if (this.isOfflineMode) {

      this.updateOfflineResult(id, result)

      return
    }

    await this.manageUploadQueue(id, result)

    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      result: result
    }

    return this.http.post(this.URL_BASE + 'perizia_upsert_result', data).toPromise();

  }




  async manageUploadQueue(id: number, data: IResult) {

    if (!data) return
    //console.log('manageUploadQueue', data)
    if (!data.fotoVetrina) data.fotoVetrina = []
    for (let i = 0; i < data.fotoVetrina.length; i++) {



      data.fotoVetrina[i].url = null
      let url = await this.addFoto('' + id, 'foto_vetrina', data.fotoVetrina[i].id, data.fotoVetrina[i].img);
      //data.fotoVetrina[i].thumbData=null;

      if (url) {
        data.fotoVetrina[i].img = url

      }
    }

    if (!data.altriElementi) data.altriElementi = []
    for (let i = 0; i < data.altriElementi.length; i++) {
      data.altriElementi[i].url = null
      let url = await this.addFoto('' + id, 'altri_elementi', data.altriElementi[i].id, data.altriElementi[i].img);
      //data.altriElementi[i].thumbData=null;
      if (url) {
        data.altriElementi[i].img = url
      }
    }


    if (!data.documenti) data.documenti = []
    for (let i = 0; i < data.documenti.length; i++) {
      data.documenti[i].url = null
      let url = await this.addFoto('' + id, 'documenti', data.documenti[i].id, data.documenti[i].img);
      //data.documenti[i].thumbData=null;
      if (url) {
        data.documenti[i].img = url
      }
    }

    if (!data.attachments) data.attachments = []
    for (let i = 0; i < data.attachments.length; i++) {

      //console.log(data.attachments[i])

      data.attachments[i].url = null
      let url = await this.addFoto('' + id, 'attachments', data.attachments[i].id, data.attachments[i].img);
      //data.attachments[i].thumbData=null;
      if (url) {
        data.attachments[i].img = url
      }
    }

    if (!data.damages) data.damages = []
    for (let i = 0; i < data.damages.length; i++) {
      data.damages[i].img1.url = null
      let url1 = await this.addFoto('' + id, 'danni', data.damages[i].img1.id, data.damages[i].img1.img);
      //data.damages[i].img1.thumbData=null;
      if (url1) {
        data.damages[i].img1.img = url1
      }

      /*
      let url2 = await this.addFoto('' + id, 'danni', data.damages[i].img2.id, data.damages[i].img2.img);
      //data.damages[i].img2.thumbData=null;
      if (url2) {
        data.damages[i].img2.img = url2
      }
      */


    }

    if (!data.damagesInt) data.damagesInt = []
    for (let i = 0; i < data.damagesInt.length; i++) {
      data.damagesInt[i].img1.url = null
      let url1 = await this.addFoto('' + id, 'danniInt', data.damagesInt[i].img1.id, data.damagesInt[i].img1.img);
      //data.damages[i].img1.thumbData=null;
      if (url1) {
        data.damagesInt[i].img1.img = url1
      }

      if (data.damagesInt[i].img2) {
        data.damagesInt[i].img2.url = null
        let url2 = await this.addFoto('' + id, 'danniInt', data.damagesInt[i].img2.id, data.damagesInt[i].img2.img);
        //data.damages[i].img2.thumbData=null;
        if (url2) {
          data.damagesInt[i].img2.img = url2
        }
      }



    }

    if (!data.glasses) data.glasses = []
    for (let i = 0; i < data.glasses.length; i++) {
      data.glasses[i].img1.url = null
      let url1 = await this.addFoto('' + id, 'glasses', data.glasses[i].img1.id, data.glasses[i].img1.img);
      //data.damages[i].img1.thumbData=null;
      if (url1) {
        data.glasses[i].img1.img = url1
      }

      data.glasses[i].img2.url = null
      let url2 = await this.addFoto('' + id, 'glasses', data.glasses[i].img2.id, data.glasses[i].img2.img);
      //data.damages[i].img2.thumbData=null;
      if (url2) {
        data.glasses[i].img2.img = url2
      }

    }

    if (data.tiresData && data.tiresData.tires)
      for (let i = 0; i < data.tiresData.tires.length; i++) {

        let tire = data.tiresData.tires[i]

        for (let j = 0; j < tire.img?.length; j++) {

          let img = tire.img[j]

          img.url = null
          let url1 = await this.addFoto('' + id, 'tires', `${i}_${j}`, img.img);
          //data.damages[i].img1.thumbData=null;
          if (url1) {
            img.img = url1
          }

        }
      }



    const formVals = [
      data.formVal1,
      data.formVal2,
      data.formVal3,
      data.formVal4,
      data.formVal5,
    ].filter(Boolean);

    for (let fIndex = 0; fIndex < formVals.length; fIndex++) {
      const fv = formVals[fIndex];

      for (const key of Object.keys(fv)) {
        const field = fv[key];

        if (field?.img?.fileContent) {
          const tempFileContent = field.img.fileContent;
          field.img.fileContent = null;

          const url = await this.addFoto('' + id, `formVal${fIndex + 1}`, key, tempFileContent);

          if (url) {
            field.img.url = url;
          }

          field.img.fileContent = tempFileContent;
        }
      }
    }


  }

  async addFoto(id: string, prefix: string, attachmentId: any, image: string) {

    //console.log(image)

    if (!image || image == '') {
      //console.log('già uploadata 1')
      return null; // già uploadata
    }
    if (image.slice(0, 4) == 'file') {
      //console.log('già uploadata 2')
      return null; // già uploadata
    }
    //console.log('addFoto', id, prefix, attachmentId, image)

    //console.log('attachmentId', attachmentId)


    if (attachmentId == null) {
      attachmentId = MD5(image)
    }

    let pathname = (this.platform.is('android') ? '' : 'Documents/') + `UxpertPRO/${id}/${prefix}`
    let filename_local = `${attachmentId}.jpg`;


    let filename = `files/automotive_insurance/${id}/${prefix}/${attachmentId}.jpg`;

    let dir = this.platform.is('android') ? Directory.Documents : Directory.Documents



    //console.clear()
    //console.log('savelocal')
    //if (this.platform.is('capacitor'))
    await this.savelocal(dir, pathname, filename_local, image)

    await this.pushtoUploadQueue(filename, image);



    return filename;

  }

  async savelocal(directory, pathname, filename, data: string) {

    try {

      await Filesystem.deleteFile({
        directory: directory,
        path: `${pathname}/${filename}`,
      })

    } catch (error) {

    }

    await Filesystem.writeFile({
      directory: directory,
      path: `${pathname}/${filename}`,
      data: data,
      recursive: true
    })

      //this.file.writeFile(pathbase, pathname + '/' + filename, blob, { append: false, replace: true })

      .then(res => { })
      .catch(err => {
        //alert('savelocal - writeFile err ' + JSON.stringify(err))
      })


  }

  async pushtoUploadQueue(filename: string, content: string) {

    //content = content.replace('data:image/jpeg;base64,', '')
    //await thumbnailify('data:image/jpeg;base64,' + content, 1920, 100).then(res => content = res)

    content = 'data:image/jpeg;base64,' + content.replace('data:image/jpeg;base64,', '')


    //console.clear()
    //console.log(content)

    console.log('pushtoUploadQueue')
    console.log('pushtoUploadQueu ' + filename)

    let md5 = MD5(content.replace('data:image/jpeg;base64,', ''))

    let el: IFileQueue = {
      filename: filename,
      content: content,
      md5: md5
    }
    console.log('el: ', el);

    this.uploadQueue.push(el);

    await this.backupUploadQueueElement(el)

    this.resumeUploadService();


  }

  async resumeUploadService() {


    this.setQueueNotification()

    if (this.uploadInProgress !== null) {
      console.warn('Upload in progress, skipping this call to resumeUploadService');
      return
    };
    if (this.uploadQueue.length <= 0) {
      //await LocalNotifications.cancel({
      //  notifications: [{ id: this.NOTIFICATION_ID }]
      //});
      console.warn('Upload queue is empty, nothing to upload');
      return
    };

    this.uploadStatus = 'uploading';

    let skipped = false;

    for (let i = 0; i < this.uploadQueue.length; i++) {

      let x = i;
      if (this.uploadQueue[x] == null) continue;

      let item = JSON.parse(JSON.stringify(this.uploadQueue[x]))
      console.log('item_index: ', item);

      try {
        let value = await this.ionicStorage.get('uq_' + item.filename.replace('uq_', ''))
        console.log('value: ', value);

        item = { ...value }

      } catch (error) {
        console.error('resumeUploadService ionicStorage.get err', error)
        continue
      }




      this.uploadInProgress = x;

      if (!this.uploadQueue || !item || !item.content || item.content == '') { skipped = true; continue };



      let data = {
        auth: this.userService.getCurrentUser(),
        data: JSON.parse(JSON.stringify(item))
      }

      data.data.filename.replace('uq_', '')

      let res = await this.http.post(this.URL_BASE + 'perizie_upload_file', data).toPromise() as any
      console.log('perizie_upload_file  ');




      if (res.status == 'OK') {
        await this.ionicStorage.remove('uq_' + item.filename.replace('uq_', '')).catch(err => console.log(err.message))
        //this.uploadQueue.splice(x, 1);
        this.setQueueNotification(this.uploadQueue.length - 1)
        console.log('foto caricata ' + item.filename);
      }





      this.uploadInProgress = null;
      console.log('this.uploadQueue.length: ', this.uploadQueue.length);

      if (this.uploadQueue.length == 1) {
        this.uploadStatus = 'done';
      }


      this.restoreUploadQueue(true);
      return

    }

    if (skipped) this.resumeUploadService()

  }


  async checkMd5(img: string): Promise<any> {
    return this.http.get(this.URL_BASE + 'get_perizia_result_image_md5&img=' + img).toPromise()
  }

  async backupUploadQueueElement(el: IFileQueue) {
    try {
      //if (this.platform.is('capacitor'))
      console.log('uq_' + el.filename)
      let r = await this.ionicStorage.set('uq_' + el.filename, el)/*.then(res=>alert(JSON.stringify(res)))*/
        .catch(err => alert(err.message))

      el.content = undefined

      //console.log('r: ', r);
      //else
      //  localStorage.setItem('uq_' + el.filename, JSON.stringify(el))
    } catch (error) {
      alert('backupUploadQueueElement' + error.message)
    }

  }

  async restoreUploadQueue(start: boolean) {

    console.log('restoreUploadQueue: ');


    let tmp: IFileQueue[] = [];

    let keys;
    await this.ionicStorage.keys().then(async res => {
      keys = res.filter(key => key.substr(0, 3) == 'uq_');
    })

    let n = keys.length;
    //alert("keys.length " + n)

    if (n == 0) {
      this.uploadQueue = []
      return;
    }


    for (let i = 0; i < keys.length; i++) {

      let el: IFileQueue = {
        filename: keys[i],
        content: '',
        md5: ''
      }

      tmp.push(el)

      //alert("key: " + keys[i])
      /*
            await this.ionicStorage.get(keys[i]).then(value =>
              tmp.push(JSON.parse(value))
            ).catch(err => {
              alert(JSON.stringify(err))
            })
      */
    }



    //alert("loaded")

    this.uploadQueue = []
    this.uploadQueue = tmp;

    n = tmp.length;
    //alert("uploadQueue.length " + n)


    if (n <= 0) return

    if (start) {
      //this.backgroundMode.enable();
      this.resumeUploadService();
    }


  }

  NOTIFICATION_CH = 'silence_channel'
  NOTIFICATION_ID = 100
  NOTIFICATION_DATA: ScheduleOptions
  channelExists = false

  async setQueueNotification(n = this.uploadQueue.length) {
    console.log('setQueueNotification: ', this.uploadQueue);

    //if (n > 0) this.resumeUploadService()

    let nData: ScheduleOptions = {
      notifications: [
        {
          title: n > 0 ? 'Upload immagini in corso' : 'Upload completato',
          body: n > 0 ? `${n} file in coda per l'upload` : 'Nessun file da caricare',
          id: this.NOTIFICATION_ID,
          channelId: this.NOTIFICATION_CH,
          sound: 'silence.mp3',
        }
      ]
    };
    console.log('nData: ', nData);
    this.NOTIFICATION_DATA = nData
    await LocalNotifications.createChannel({
      id: this.NOTIFICATION_CH, name: 'File Upload',

      sound: 'silence.mp3',
      importance: 3,
      vibration: false,
      visibility: 1
    })
    await LocalNotifications.schedule(nData);


  }

  restartService() {
    this.uploadInProgress = null;
    this.restoreUploadQueue(true);
  }


  clearAllUploadQueue() {

    if (!confirm("SEI SICURO di voler eliminare tutti i file in upload?")) return;

    this.ionicStorage.clear().then(res => {
      this.restoreUploadQueue(true);
    })
  }

  get_perizia_result(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'get_perizia_result', data).toPromise();
  }

  get_perizia_attachment_url(id: number, f: IFile, type: string) {
    return `${this.URL_BASE}get_perizia_attachment&id=${id}&hash=${f.hash}&filename=${f.fileName}&type=${type}`;
  }


  unipolrental_o2_send_vdr(id: number, imgs: IFile[], pdf: IFile, causale: string, saveToP = true, sendEmail = true): Promise<any> {

    let data = {
      auth: this.userService.getCurrentUser(),

      id: id,
      imgs: imgs,
      saveToP: saveToP,
      sendEmail: sendEmail,
      pdf: pdf,
      causale: causale

    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'unipolrental_o2_send_vdr', data).toPromise();
  }

  app_final_check(pData: any): Promise<any> {

    let data = {
      auth: this.userService.getCurrentUser(),
      data: pData
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'app_final_check', data).toPromise();
  }

  app_list(): Promise<any> {

    console.log('this.isOfflineMode: ', this.isOfflineMode);
    if (this.isOfflineMode) {
      console.log('Offline mode: returning offline data')
      return new Promise(async resolve => resolve({ list: await this.getOfflineData() }));
    }

    let data = {
      auth: this.userService.getCurrentUser(),
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'app_list', data).toPromise();
  }

  list_perizie(type: string = '', ids = [], limit = 0, stato = '', filterYear = { y1: 0, y2: 3000 }, filters = {}): Promise<any> {

    let data = {
      auth: this.userService.getCurrentUser(),
      type: type,
      ids: ids,
      limit: limit,
      stato: stato,

      filters: filters
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'list_perizie', data).toPromise();
  }

  list_storico_perizia(id: number): Promise<any> {
    return this.list_storico('perizie', id)
  }

  list_storico(table: string, id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      table: table,
      id: id
    }

    return this.http.post(this.URL_BASE + 'list_storico', data).toPromise();
  }

  list_logs_perizia(id: number): Promise<any> {
    return this.list_logs('perizie', id)
  }

  list_logs(table: string, id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      table: table,
      id: id
    }

    return this.http.post(this.URL_BASE + 'list_logs', data).toPromise();
  }

  upsert_perizia(item: IPerizia): Observable<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      item: item
    }


    const request = new HttpRequest('POST', this.URL_BASE + 'upsert_perizia', data, {
      reportProgress: true
    });



    return this.http.request(request);
  }

  upsert_perizia_accept_reject(id: number, nextStatus: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      nextStatus: nextStatus
    }

    return this.http.post(this.URL_BASE + 'upsert_perizia_accept_reject', data).toPromise();
  }


  upsert_allegati_perizia(item: IPerizia): Observable<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      item: item
    }


    const request = new HttpRequest('POST', this.URL_BASE + 'upsert_allegati_perizia', data, {
      reportProgress: true
    });



    return this.http.request(request);
  }

  delete_perizia(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    return this.http.post(this.URL_BASE + 'delete_perizia', data).toPromise();
  }



  get_current_user_profile(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
    }

    return this.http.post(this.URL_BASE + 'get_current_user_profile', data).toPromise();

  }

  //////////////////////////////////////////////////////////////////////////////////////////


  getListChat(code: string, email: string): Observable<IChat[]> {

    let data = {
      auth: this.userService.getCurrentUser(),
      code: code,
      email: email
    }

    return this.http.post<IChat[]>(this.URL_BASE + 'list-chat', data);

  }


  getListChatNotifies(): Promise<any> {

    let data = {
      auth: this.userService.getCurrentUser()
    }

    return this.http.post<IChat[]>(this.URL_BASE + 'list-chat-notifies', data).toPromise();

  }

  addChat(chat: IChat): Promise<any> {

    if (!chat.sender) chat.sender = this.userService.user.email;

    let data = {
      auth: this.userService.getCurrentUser(),
      data: chat
    }

    console.log(data)

    return this.http.post<IChat[]>(this.URL_BASE + 'add-chat', data).toPromise();

  }


  //////////////////////////////////////////////////////////////////////////////////////////

  login(email: string, password: string): Promise<any> {

    return this.http.post(this.URL_BASE + 'login', { email: email, password: password }).toPromise();

  }

  get_stats(hideCompleted = true): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      hideCompleted: hideCompleted
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'get_stats', data).toPromise();

  }

  getTipoPerizia() {
    return [
      'Stato d\'uso',
      'Buyback',
      'RC Auto',
      'Kasco collisione',
      'Fenomeni socio-politici',
      'Furto totale con ritrovamento',
      'Incendio e scoppio',
      'RC Prodotto',
      'Rivalse',
      'Globale fabbricati',
      'Danno merci',
      'Preassuntiva',
      'Kasco completa',
      'Atti vandalici',
      'Fenomeni naturali',
      'Furto parziale',
      'Cristalli',
      'RC Professionale',
      'RC Generale',
      'Acqua condotta',
      'Merci trasportate',
      'Stato d\'uso',
      'Uxpert'
    ]
  }

  getStatiPerizia(): any[] {

    if (this.stati_perizia) {
      return this.stati_perizia;
    }

    if (!this.stati_perizia) {
      return JSON.parse(localStorage.getItem('stati_perizia'));
    }


  }

  getMarche(): any[] {

    if (this.marche) {
      return this.marche;
    }

    if (!this.marche) {
      return JSON.parse(localStorage.getItem('marche'));
    }


  }

  getStato(sts) {

    let stati = this.getStatiPerizia();


    for (let i = 0; i < stati.length; i++) {
      if (sts == stati[i].sts) {
        return stati[i]
      }
    }

    return { competence: '' };
  }

  getStatiPeriziaAll(): string[] {
    let stati = this.getStatiPerizia();

    let r = [];
    for (let i = 0; i < stati.length; i++) {
      r.push(stati[i].sts);
    }

    return r;
  }

  getStatiPeriziaAll_client(): string[] {
    let stati = this.getStatiPerizia();

    let r = [];
    for (let i = 0; i < stati.length; i++) {
      r.push(stati[i].clientDescription);
    }

    r = r.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    return r;
  }

  getPeriziaStatusFilter(): any[] {
    let r = [];
    let arr = this.userService.user.role == 'CLIENTE' ? this.getStatiPeriziaAll_client() : this.getStatiPeriziaAll();
    for (let e of arr) {
      r.push({ value: e, title: e })
    }
    return r;
  }

  leggi_targa_base64(image_base64: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      image_base64: image_base64
    }

    return this.http.post(this.URL_BASE + 'claude_leggi_targa_base64', data).toPromise();
  }


}


export interface IFileQueue {
  filename: string;
  content: string;
  uploadTask?: any;
  md5: string;
}
